import { useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { PurchaseOrderStatusCounts } from "../types";
import { queryKeys } from "./queryKeys";

const fetchPurchaseOrderCounts =
  async (): Promise<PurchaseOrderStatusCounts> => {
    const { data } = await axios.get("/purchase-orders/count-by-status");
    return data;
  };

/** The viewer's company live-OC count per status (every status present, zero-filled) — feeds the summary tiles. */
export const usePurchaseOrderCounts = () =>
  useQuery<PurchaseOrderStatusCounts, Error>({
    queryKey: [queryKeys.PURCHASE_ORDER_COUNTS],
    queryFn: fetchPurchaseOrderCounts,
  });
